"use client";
import type { ReactElement } from "react";
import type { GanttDependencyLineLayout } from "./gantt-render-selectors";
export interface GanttDependencyLayerProps {
    ganttIdPrefix: string;
    dependencyLineLayouts: GanttDependencyLineLayout[];
}
export function GanttDependencyLayer({ ganttIdPrefix, dependencyLineLayouts, }: GanttDependencyLayerProps): ReactElement {
    return (<>
      {dependencyLineLayouts.map((line) => (<line key={`${ganttIdPrefix}-dep-${line.id}`} x1={line.x1} y1={line.y1} x2={line.x2} y2={line.y2} stroke={`${line.color}66`} strokeDasharray="4 3" strokeWidth={1}/>))}
    </>);
}
